import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The asinine pricing of Snow Leopard",
  "description": "",
  "published": "2009-08-26T00:00:00.000Z",
  "redirect_from": ["/blog/the-asinine-pricing-of-snow-leopard/swizec/700"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://commons.wikipedia.org/wiki/Image:L%C3%A9opard_des_neiges_14082.jpg"
        }}></a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      